import React from "react";
import { Box, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { TRANSITION } from "../Theme/styles";

export const WZOR_OBRAZKA =/https?:\/\/[^\s]+?\.(?:png|jpe?g|gif|webp)(?:\?[^\s]*)?/gi;

const TaskDescription = ({ description }) => {
  if (!description) return <Text>Brak opisu</Text>;

  const images = description.match(WZOR_OBRAZKA) || [];
  const tekst = description.replace(WZOR_OBRAZKA, "").trim();

  const columns = images.length === 1 ? 1 : images.length <= 4 ? 2 : 3;

  return (
    <Box>
      {tekst && <Text whiteSpace={"pre-wrap"}>{tekst}</Text>}

      {images.length > 0 && (
        <SimpleGrid
          columns={{ base: 1, md: columns }}
          spacing={2}
          mt={tekst ? 3 : 0}
        >
          {images.map((url, i) => (
            <Box
              key={`${url}-${i}`}
              as="a"
              href={url}
              target="_blank"
              rel="noreferrer"
              borderRadius="md"
              overflow="hidden"
              display="block"
              transition={TRANSITION}
              _hover={{ opacity: 0.85 }}
            >
              <Image
                src={url}
                alt="Załącznik"
                w="100%"
                h={images.length === 1 ? "auto" : "160px"}
                maxH={images.length === 1 ? "420px" : undefined}
                objectFit={images.length === 1 ? "contain" : "cover"}
              />
            </Box>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default TaskDescription;
